export default "__VITE_ASSET__87476e4c__"